<div class="nav-header">
  <svg-icon class="company-logo {{ coBrand }}" [icon]="'icon_' + logo" />
  <dmb-switch-client />
  <div class="menu-toggle" (click)="toggleMainMenu()">
    <svg-icon class="toggle-icon" [icon]="'icon_' + toggleIcon()" />
  </div>
</div>
<div class="search">
  <div class="search-icon" (click)="expandSearch($event)"><svg-icon icon="icon_search" /></div>
  <dmb-search (searching)="handleSearch($event)" (click)="$event.stopPropagation()" />
</div>
